import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import DirectoryApi from "../../api/directory";
import useCallApi from "../../hooks/useCallApi";
import { Routes } from "../../routes/Routes";
import { useAlert } from "../../context/AlertContext";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";

const useDirectoriesContainer = () => {
  const navigate = useNavigate();
  const { callApi, loading } = useCallApi();
  const { setSuccessMessage } = useAlert();
  const { isRTL } = useRTL();
  const { directories } = useContent().pages;
  const [pageLoading, setPageLoading] = useState(true);

  const [allDirectories, setAllDirectories] = useState([]);
  const [searchedDirectories, setSearchedDirectories] = useState([]);

  const [searchValue, setSearchValue] = useState("");

  const [selected, setSelected] = useState<any>(null);

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(6);

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };

  useEffect(() => {
    setPageLoading(true);
    callApi(DirectoryApi.getAll(), (directories: any) => {
      setAllDirectories(directories);
      setSearchedDirectories(directories);
      setPageLoading(false);
    });
  }, [isRTL]);

  const handleSearch = (value: string) => {
    setSearchValue(value);
    setPage(1);
    if (value.trim() === "") {
      setSearchedDirectories(allDirectories);
    } else {
      setSearchedDirectories(
        allDirectories.filter((directory: any) =>
          directory.name.toLowerCase().includes(value.toLowerCase())
        )
      );
    }
  };

  const handleOpenDelete = (row: any) => {
    setSelected(row);
    setOpenDeleteDialog(true);
  };

  const handleDelete = () => {
    callApi(DirectoryApi.delete(selected.id), () => {
      setAllDirectories(
        allDirectories.filter((directory: any) => directory.id !== selected.id)
      );
      setSearchedDirectories(
        allDirectories.filter(
          (directory: any) =>
            directory.id !== selected.id &&
            directory.name.toLowerCase().includes(searchValue.toLowerCase())
        )
      );
      setSelected(null);
      setOpenDeleteDialog(false);
      setSuccessMessage(directories.deleteDir);
    });
  };

  const handleEdit = (id: string) => {
    navigate(Routes.getEditDirectory(id));
  };

  const handleClick = (id: string) => {
    navigate(Routes.getDirectory(id));
  };

  return {
    directories: searchedDirectories,
    handleSearch,
    searchValue,
    pageLoading,
    page,
    handleChangePage,
    rowsPerPage,
    handleClick,

    handleOpenDelete,
    handleDelete,
    handleEdit,
    selected,
    openDeleteDialog,
    setOpenDeleteDialog,
    loading,
  };
};

export default useDirectoriesContainer;
